import { type ReactNode } from 'react'
import { useRouter } from 'next/router'
import { usePostsCommentsInfo } from 'modules/community/api/posts-comments-info'
import { useDeletePost } from 'modules/community/api/use-delete-post'
import { useDeletePostAndBanUser } from 'modules/community/api/use-delete-post-and-ban'
import { usePinnedPosts } from 'modules/community/api/use-pinned-posts'
import { useToggleLike } from 'modules/community/api/use-toggle-like'
import { PostPinned } from './post-pinned'

export const PostPinnedList = (): ReactNode => {
  const router = useRouter()
  const { communityPath } = router.query
  const getPinnedPostsQuery = usePinnedPosts()

  const postIds = getPinnedPostsQuery.data?.map(item => item.id)
  const commentsInfoQuery = usePostsCommentsInfo({ postIds })

  const deletePostHook = useDeletePost()
  const deletePostAndBanHook = useDeletePostAndBanUser({
    communityPath: communityPath,
  })
  const toggleLike = useToggleLike()

  return (
    <>
      {getPinnedPostsQuery.data?.map(post => (
        <PostPinned
          post={post}
          key={post.id}
          deletePost={() => deletePostHook(post.id)}
          deletePostAndBanUser={removeRecentActivities =>
            deletePostAndBanHook({ postId: post.id, userId: post.userId, removeRecentActivities })
          }
          handleLikeClick={() => toggleLike.mutate({ id: post.id, isLiked: !post.isLiked })}
          commentsInfo={commentsInfoQuery.data?.items}
          commentsInfoError={commentsInfoQuery.error}
        />
      ))}
    </>
  )
}
